import { Icon } from '@/components/Icon';
import { Linking, Platform, useWindowDimensions, View } from 'react-native';
import { Text } from '@/components/Text';
import { logError } from '@/utils/logHandling';
import { Card } from '@/components/ui/therapist/Card';
import { Button } from '@/components/ui/therapist/Button';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';
import { styles } from '@/screens/TherapistSettings/Contact/styles';
import { BodyWrapper } from '@/layouts/BodyWrapper';

const handlePressMap = {
  email: {
    url: 'mailto:info@neolexon.de',
    notSupportedErrorMessage: 'Bitte richten Sie E-Mails für Ihr Gerät ein',
    errorMessage: 'Error opening email',
  },
  phone: {
    url: 'tel:+4989248864440',
    notSupportedErrorMessage:
      'Mit diesem Gerät können keine Anrufe getätigt werden',
    errorMessage: 'Error placing call',
  },
};

export function Contact() {
  const { showNotification } = useNotification();
  const { width } = useWindowDimensions();
  const isSmallScreenSize = width < 720;

  const handlePress = async ({
    url,
    notSupportedErrorMessage,
    errorMessage,
  }: {
    url: string;
    notSupportedErrorMessage: string;
    errorMessage: string;
  }) => {
    try {
      const supported = await Linking.canOpenURL(url);

      if (!supported && Platform.OS === 'ios') {
        showNotification({
          title: notSupportedErrorMessage,
          type: 'error',
        });
        return;
      }

      await Linking.openURL(url);
    } catch (error) {
      showNotification({
        title: errorMessage,
        type: 'error',
      });
      logError(`${errorMessage}:`, error);
    }
  };

  return (
    <BodyWrapper>
      <Card>
        <Text>
          Sie haben Fragen oder ein anderes Anliegen? Wir sind gerne für Sie da
          und unterstützen Sie bei allem rund um die App.
        </Text>
      </Card>
      <Card styleBody={{ paddingHorizontal: 0 }}>
        <View
          style={[
            styles.contactWrapper,
            { flexDirection: isSmallScreenSize ? 'column' : 'row' },
          ]}
        >
          <View
            style={[
              styles.emailWrapper,
              isSmallScreenSize && {
                width: '100%',
                justifyContent: 'space-between',
              },
            ]}
          >
            <View style={styles.emailWrapper}>
              <Icon name={'email'} size={32} />
              <Text style={styles.emailText}>E-Mail</Text>
            </View>
            <Text style={{ paddingLeft: 12 }}>info@neolexon.de</Text>
          </View>
          <Button
            style={isSmallScreenSize ? styles.emailButtonSmall : null}
            label="E-Mail schreiben"
            onPress={() => handlePress(handlePressMap['email'])}
          />
        </View>
        <View
          style={[
            styles.phoneWrapper,
            { flexDirection: isSmallScreenSize ? 'column' : 'row' },
          ]}
        >
          <View style={styles.phoneTextAndIconWrapper}>
            <Icon name={'phone'} size={32} />
            <View style={styles.phoneTextWrapper}>
              <View style={styles.phoneNumberWrapper}>
                <Text style={{ fontWeight: 600 }}>Telefon</Text>
                <Text style={{ paddingLeft: 12 }}>+49 (0)89 24886 4440</Text>
              </View>
              <Text>
                Sie erreichen uns Montag bis Freitag von 8:00 bis 15:00 Uhr.
              </Text>
            </View>
          </View>
          <View
            style={
              isSmallScreenSize
                ? { width: '100%', marginTop: 16 }
                : { marginLeft: 12, flexShrink: 0 }
            }
          >
            <Button
              style={{
                justifyContent: 'center',
                alignSelf: isSmallScreenSize ? 'stretch' : 'flex-start',
              }}
              label="Anrufen"
              onPress={() => handlePress(handlePressMap['phone'])}
              look="secondary"
            />
          </View>
        </View>
      </Card>
    </BodyWrapper>
  );
}
